import { StringHash } from '@app/shared/utils/utils-types';
import { SimpleTopic } from '../../../origami-api/utils/topic-utils';
import { BaseSettingsModule } from './settings-module-base';
import { SettingValue } from './setting-value';

export class CustomSettingsModule extends BaseSettingsModule {
  val(dbName: string): SettingValue<any> {
    const defaultStore = this.defaultStore ? this.defaultStore[this.moduleName] : null;
    return new SettingValue<any>(dbName, '', this.mainStore[this.moduleName], defaultStore, (field) =>
      this.saveData({
        TopicName: this.moduleName,
        TopicFields: [field],
      }),
    );
  }

  getValues(): StringHash<any> {
    const result = {};
    Object.keys(this.mainStore[this.moduleName]).forEach((key) => (result[key] = this.val(key).get()));
    return result;
  }

  getDbValues(returnOnlyDirty: boolean = true): SimpleTopic {
    const topicFields = Object.keys(this.mainStore[this.moduleName])
      .map((key) => this.val(key).getDbValue(returnOnlyDirty))
      .filter((v) => v);

    return topicFields.length
      ? {
          TopicName: this.moduleName,
          TopicFields: topicFields,
        }
      : null;
  }
}
